export class gradeResponse {
    grade:string;
    qty:number;
    cartons: number
    loosePouches : number
    gradeName : string
    antibioticTestResult?:boolean
    constructor(grade:string,
        qty:number,cartons:number,loosePouches : number,gradeName : string,antibioticTestResult?:boolean){
        this.grade = grade;
        this.qty = qty;
        this.cartons = cartons
        this.loosePouches = loosePouches
        this.gradeName = gradeName
        this.antibioticTestResult = antibioticTestResult

    }
}
export class StockSummaryResponse {
    variant:string;
    unit:string;
    totalCartons:number;
    gradeQty:gradeResponse[];
    prodShortCode:string;
    totalQty : number
    packStyle : string;
    totalLoosePouches : number;
    antibioticTestResult ?:boolean
    
    constructor(variant:string,unit:string,totalCartons:number,
        gradeQty:gradeResponse[],prodShortCode:string,totalQty : number,packStyle : string,totalLoosePouches : number,antibioticTestResult?:boolean){
            this.variant = variant;
            this.totalCartons  = totalCartons;
            this.unit = unit;
            this.gradeQty = gradeQty;
            this.prodShortCode = prodShortCode;
            this.totalQty = totalQty
            this.packStyle = packStyle
            this.totalLoosePouches = totalLoosePouches
            this.antibioticTestResult = antibioticTestResult
    }
}